import { Fragment } from 'react';
import home1 from '../images/Container_sq.jpg';
import home2 from '../images/home2.jpg';
import './pages.css';
import Footer from '../pages/Footer';
import ExpandableSection from "./ExpandableSection";

const Home = () => {
    return (
        <Fragment>
            <img src={ home1 } className= { 'avatar-home' } alt="avatar" />
            <div className={ 'home-content' }>
                <div className={ 'company-content-container' }>
                    <h1>The Company</h1>
                    <p>We are Vanadium: Your comprehensive solution for the management of industrial surpluses. We help you reduce costs,
                       improve efficiency and protect the environment. Vanadium provides a premier metal trading experience, offering 
                       competitive prices, leveraging strong connections with various industry's top leaders in Europe, America and 
                       Asia-pacific.
                    </p>
                </div>

                <div className={ 'what-content-container' }>
                    <div className={ 'what-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>What we do?</h2>
                        <hr size="2" color="blue" />
                        <ul className="what-content-list">
                            <li><strong>Import-Export:</strong>  Manage industrial surpluses</li>
                            <li><strong>Metals:</strong> Copper, Iron, Aluminium, Zinc, etc.</li>
                            <li><strong>Minerals:</strong> Copper, Lithium, etc.</li>
                            <li><strong>Energy Waste:</strong> Solar energy supplies and generating stations, etc.</li>
                            <li><strong>Other Industrial Surpluses:</strong> Various mining and industrial metal scrap, etc.</li>
                        </ul>
                    </div>
                    <img align="right" src={ home2 } className="avatar" alt="avatar" width="300px" height="270px" />
                </div>

                <div className={ 'why-content-container' }>
                    <h2>Why choose us?</h2>
                    <div className={ 'why-content-sections' }>
                        <ExpandableSection
                            heading="Experience and knowledge"
                            content="We have a highly qualified team with extensive experience in industrial surplus management."
                        />
                        <ExpandableSection
                            heading="Modern infrastructure"
                            content="Our San Bernardo plant is equipped with the latest technology for processing and managing surpluses."
                        />
                        <ExpandableSection
                            heading="Wide network of contacts"
                            content="We have a wide network of contacts in the national and international market, which allows us to find the best buyers for your surpluses."
                        />
                        <ExpandableSection
                            heading="Commitment to the environment"
                            content="We are a company committed to the environment and we have all the necessary environmental resolutions to give a verifiable final destination to its surpluses."
                        />
                        <ExpandableSection
                            heading="Strong national presence"
                            content="We have the capacity to operate throughout the national territory, which allows us to serve clients from all industrial sectors."
                        />
                        <ExpandableSection
                            heading="Great purchasing power"
                            content="We have great purchasing power, which allows us to offer competitive prices to our customers."
                        />
                    </div>
                </div>
            </div>
            <Footer />

        </Fragment>
    )
};
export default Home;
